var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _sliceInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/slice");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs3/core-js/instance/slice", "@babel/runtime-corejs3/core-js/set-timeout"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs3/core-js/instance/slice"), require("@babel/runtime-corejs3/core-js/set-timeout"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, _sliceInstanceProperty2(global), global.setTimeout);
    global.util = mod.exports;
  }
})(this, function (_exports, _slice, _setTimeout2) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.debounce = debounce;
  _exports.merge = merge;
  _exports.isFunction = isFunction;
  _exports.arrayFrom = arrayFrom;
  _slice = _interopRequireDefault(_slice);
  _setTimeout2 = _interopRequireDefault(_setTimeout2);

  /**
   * debounce
   *
   * @param {Function} func 实际要执行的函数
   * @param {Number} delay 延迟时间，单位是 ms
   * @param {Function} callback 在 func 执行后的回调
   *
   * @return {Function}
   */
  function debounce(func, delay, callback) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = (0, _setTimeout2.default)(function () {
        func.apply(context, args);
        !callback || callback();
      }, delay);
    };
  }
  /**
   * merge
   *
   * @param  {Object} src
   * @param  {Object} dest
   * @return {Object}
   */


  function merge(src, dest) {
    for (var item in src) {
      dest[item] = src[item];
    }

    return dest;
  }
  /**
   * 是否是函数
   *
   * @param  {Any} func 判断对象
   * @return {Boolean}
   */


  function isFunction(func) {
    return Object.prototype.toString.call(func) === '[object Function]';
  }
  /**
   * 将类数组转化成数组
   *
   * @param  {Object} arrayLike 类数组对象
   * @return {Array} 转化后的数组
   */


  function arrayFrom(arrayLike) {
    return (0, _slice.default)([]).call(arrayLike);
  }
});